// Calm Tails — JS propio (ct-). Vanilla, sin librerías.

document.addEventListener('DOMContentLoaded', () => {
  initRevealOnScroll();
  initSlidersAntesDespues();
});

function initRevealOnScroll() {
  if (window.ctRevealInitialized) return;
  window.ctRevealInitialized = true;

  const elements = document.querySelectorAll('.ct-reveal');
  if (!elements.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    elements.forEach((el) => el.classList.add('ct-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ct-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  elements.forEach((el) => observer.observe(el));
}

function initSlidersAntesDespues() {
  if (window.ctSlidersInitialized) return;
  window.ctSlidersInitialized = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const AUTO_MIN = 18;
  const AUTO_MAX = 82;
  const AUTO_VELOCIDAD = 0.18; // % por fotograma
  const AUTO_ESPERA_REANUDAR = 1800; // ms tras soltar antes de retomar el auto-deslizado

  function initSlider(sliderEl) {
    const capaAntes = sliderEl.querySelector('.ct-slider__capa--antes');
    const linea = sliderEl.querySelector('.ct-slider__linea');
    const manija = sliderEl.querySelector('.ct-slider__manija');
    if (!capaAntes || !manija) return;

    let percentActual = 50;
    let direccionAuto = 1;
    let autoActivo = false;
    let autoRafId = null;
    let reanudarTimeoutId = null;

    function setPercent(percent) {
      percent = Math.max(0, Math.min(100, percent));
      percentActual = percent;
      capaAntes.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
      linea.style.left = percent + '%';
      manija.style.left = percent + '%';
      manija.setAttribute('aria-valuenow', Math.round(percent));
    }

    function pasoAuto() {
      if (!autoActivo) return;
      let siguiente = percentActual + AUTO_VELOCIDAD * direccionAuto;
      if (siguiente >= AUTO_MAX) { siguiente = AUTO_MAX; direccionAuto = -1; }
      if (siguiente <= AUTO_MIN) { siguiente = AUTO_MIN; direccionAuto = 1; }
      setPercent(siguiente);
      autoRafId = requestAnimationFrame(pasoAuto);
    }

    function iniciarAuto() {
      if (prefersReducedMotion || autoActivo) return;
      autoActivo = true;
      autoRafId = requestAnimationFrame(pasoAuto);
    }

    function detenerAuto() {
      autoActivo = false;
      if (autoRafId) cancelAnimationFrame(autoRafId);
      if (reanudarTimeoutId) clearTimeout(reanudarTimeoutId);
    }

    function programarReanudar() {
      if (reanudarTimeoutId) clearTimeout(reanudarTimeoutId);
      reanudarTimeoutId = setTimeout(iniciarAuto, AUTO_ESPERA_REANUDAR);
    }

    function percentFromClientX(clientX) {
      const rect = sliderEl.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    let dragging = false;

    function onPointerDown(e) {
      dragging = true;
      detenerAuto();
      sliderEl.classList.add('ct-slider--arrastrando');
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPercent(percentFromClientX(clientX));
    }
    function onPointerMove(e) {
      if (!dragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPercent(percentFromClientX(clientX));
    }
    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      sliderEl.classList.remove('ct-slider--arrastrando');
      programarReanudar();
    }

    sliderEl.addEventListener('mousedown', onPointerDown);
    sliderEl.addEventListener('touchstart', onPointerDown, { passive: true });
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: true });
    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);

    manija.addEventListener('keydown', (e) => {
      const current = parseFloat(manija.style.left) || 50;
      if (e.key === 'ArrowLeft') { detenerAuto(); setPercent(current - 5); programarReanudar(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { detenerAuto(); setPercent(current + 5); programarReanudar(); e.preventDefault(); }
    });

    // Auto-deslizado solo mientras el comparador esté visible en pantalla (ahorra batería/CPU)
    const observadorVisibilidad = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!dragging) iniciarAuto();
          } else {
            detenerAuto();
          }
        });
      },
      { threshold: 0.2 }
    );
    observadorVisibilidad.observe(sliderEl);
  }

  document.querySelectorAll('.ct-slider').forEach(initSlider);
}
